import React, { useState } from "react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import DatePickerButton from "../ui/date-picker-button";

const Reports = () => {
  const today = new Date().toISOString().split("T")[0];

  const [dailyDate, setDailyDate] = useState(today);
  const [zipMonth, setZipMonth] = useState("2026-07");
  const [monthlyMonth, setMonthlyMonth] = useState("2026-07");
  const [year, setYear] = useState("2026");

  const generateDaily = () => {
    console.log("Daily:", dailyDate);
  };

  const generateZip = () => {
    console.log("Zip:", zipMonth);
  };

  const generateMonthly = () => {
    console.log("Monthly:", monthlyMonth);
  };

  const generateYearly = () => {
    console.log("Year:", year);
  };

  const reportLabelClass =
    "w-full max-w-[280px] h-14 bg-muted hover:bg-muted text-foreground border border-border font-semibold cursor-default";

  const generateButtonClass =
    "w-full h-14 bg-orange-500 hover:bg-orange-600 text-white font-semibold";

  const inputClass = `
    w-full
    h-14
    rounded-md
    border
    border-border
    bg-background
    text-foreground
    px-4
    focus:outline-none
    focus:ring-2
    focus:ring-ring
    appearance-none
  `;

  return (
    <div className="space-y-8">

      {/* Header */}

      <div>
        <h1 className="text-3xl font-bold text-foreground">
          Reports
        </h1>

        <p className="mt-2 text-muted-foreground">
          Generate and download plant reports
        </p>
      </div>

      <h2 className="text-xl font-semibold text-foreground">
        Report Parameters
      </h2>

      {/* Daily Generation */}

      <Card className="bg-card border-border shadow-sm">
        <CardContent className="py-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">

            <Button
              variant="secondary"
              className={reportLabelClass}
            >
              Daily Generation Report
            </Button>

            <DatePickerButton
              selectedDate={dailyDate}
              onDateChange={setDailyDate}
              label="Select Date"
            />

            <Button
              className={generateButtonClass}
              onClick={generateDaily}
            >
              Generate Report
            </Button>

          </div>
        </CardContent>
      </Card>

      {/* Daily Generation Zip */}

      <Card className="bg-card border-border shadow-sm">
        <CardContent className="py-8">

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">

            <Button
              variant="secondary"
              className={reportLabelClass}
            >
              Daily Generation Report (Zipped)
            </Button>

            <input
              type="month"
              value={zipMonth}
              onChange={(e) => setZipMonth(e.target.value)}
              className={inputClass}
              style={{ colorScheme: "dark" }}
            />

            <Button
              className={generateButtonClass}
              onClick={generateZip}
            >
              Generate Report
            </Button>

          </div>

        </CardContent>
      </Card>

      {/* Monthly */}

      <Card className="bg-card border-border shadow-sm">
        <CardContent className="py-8">

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">

            <Button
              variant="secondary"
              className={reportLabelClass}
            >
              Monthly Generation Report
            </Button>

            <input
              type="month"
              value={monthlyMonth}
              onChange={(e) => setMonthlyMonth(e.target.value)}
              className={inputClass}
              style={{ colorScheme: "dark" }}
            />

            <Button
              className={generateButtonClass}
              onClick={generateMonthly}
            >
              Generate Report
            </Button>

          </div>

        </CardContent>
      </Card>

      {/* Yearly */}

      <Card className="bg-card border-border shadow-sm">
        <CardContent className="py-8">

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">

            <Button
              variant="secondary"
              className={reportLabelClass}
            >
              Yearly Generation Report
            </Button>

            <select
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className={inputClass}
            >
              <option value="2026">2026</option>
              <option value="2025">2025</option>
              <option value="2024">2024</option>
              <option value="2023">2023</option>
              <option value="2022">2022</option>
            </select>

            <Button
              className={generateButtonClass}
              onClick={generateYearly}
            >
              Generate Report
            </Button>

          </div>

        </CardContent>
      </Card>

    </div>
  );
};

export default Reports;